module.exports = __webpack_public_path__ + "static/media/ncj_pend_0003.cd485bb7.jpg";